const swedishTemplate = {
  greeting: "Hej, {{firstname}}!\n\n",
  closing: "\n\nVänliga hälsningar från Lea Bank",
  openingTimes: "\n\nVåra öppettider är måndag till fredag kl. 09:00–16:00.",
  offer:
    "Lånebelopp: {{finalLoanAmount}}\nAvbetalning: {{monthlyCost}}\nÅterbetalningstid: {{terms}}\nKostnader: {{termFee}}\nKontots öppningsavgift: {{startupFee}}\nNominell ränta: {{interestRate}}\nEffektiv ränta: {{effectiveInterestRate}}"
};

export const communicationTemplatesCardSE: {
  [key: string]: {
    templateName: string;
    text: string;
    variables: string[];
    templateType?: "sms" | "mail";
  };
} = {
  GENERAL_TEMPLATE: {
    templateName: "General template",
    text: `${swedishTemplate.greeting}Länk till din ansökan: {{signingLink}}.\n\nOm du har frågor kan du kontakta oss på 08 509 285 00 eller kundservice@leabank.se\n\nÖppettiderna för vårt kundcenter är 09:00 till 15:00 måndag till fredag.\n\nVi önskar dig en fortsatt trevlig dag.${swedishTemplate.closing}`,
    variables: ["firstname", "signingLink"],
    templateType: "mail"
  },
  REJECTION: {
    templateName: "Rejection",
    text: `${swedishTemplate.greeting}Vi har nu gjort en helhetsbedömning av din låneansökan och tyvärr kan vi inte hjälpa till med finansieringen den här gången.${swedishTemplate.closing}`,
    variables: ["firstname"],
    templateType: "mail"
  },
  PRE_APPROVAL: {
    templateName: "Pre-approval",
    text: `${swedishTemplate.greeting}
      Vi är glada att kunna erbjuda dig följande:\n\n
      ${swedishTemplate.offer}
      \n\nLänk till din ansökan: {{signingLink}}
      \n\nSå snart ansökan är färdigbehandlad kommer lånet att betalas ut till det angivna bankkontot.
      \n\nOm du har frågor kan du kontakta oss på 08 509 285 00 eller kundservice@leabank.se
      \n\nÖppettiderna för vårt kundcenter är 09:00 till 15:00 måndag till fredag.${swedishTemplate.closing}
      `,
    variables: [
      "firstname",
      "signingLink",
      "finalLoanAmount",
      "monthlyCost",
      "terms",
      "interestRate",
      "effectiveInterestRate",
      "startupFee",
      "termFee"
    ],
    templateType: "mail"
  },
  PRE_APPROVAL_TOPUP: {
    templateName: "Pre-approval - TopUp",
    text: `${swedishTemplate.greeting}
      Du har ansökt om utökat lån hos oss.\n\n
      Nu har vi behandlat din ansökan preliminärt och baserat på uppgifterna du har angett kan vi erbjuda dig följande:\n\n
      ${swedishTemplate.offer}
      \n\nEftersom du bara kan ha ett lån hos Lea Bank löser vi in ditt befintliga lån med ett nytt lån och betalar ut mellanskillnaden för dessa lån till ditt konto.
      \n\nLänk till din ansökan: {{signingLink}}
      \n\nSå fort din ansökan har behandlats för vi över lånet till det konto som du har angett, såvida uppgifterna i ansökan stämmer. Låneerbjudandet är giltigt i 30 dagar.
      \n\nOm du har frågor kan du kontakta oss genom att ringa 08 509 285 00 eller skicka e-post till kundservice@leabank.se
      \n\nKundtjänsten är öppen från måndag till fredag kl. 09:00–16:00.${swedishTemplate.closing}
      `,
    variables: [
      "firstname",
      "signingLink",
      "finalLoanAmount",
      "monthlyCost",
      "terms",
      "interestRate",
      "effectiveInterestRate",
      "startupFee",
      "termFee"
    ],
    templateType: "mail"
  },
  MISSING_ERROR_ACCOUNT_NUMBER: {
    templateName: "Missing or error in account number",
    text: `${swedishTemplate.greeting}
      Det angivna kontonumret är felaktigt. Vänligen skicka in hela ditt clearing och kontonummer till kundservice@leabank.se eller ring oss på 08 509 285 00. Öppettiderna för vårt kundcenter är 09:00 till 15:00 måndag till fredag.
      \n\nLänk till din ansökan: {{signingLink}}
      ${swedishTemplate.closing}`,
    variables: ["firstname", "signingLink"],
    templateType: "mail"
  },
  PRE_APPROVAL_SMS: {
    templateName: "Pre-approval",
    text: `${swedishTemplate.greeting}Vi har skickat ett preliminärt låneerbjudande till dig via e-post. Kontakta oss om du har frågor gällande din ansökan.\n\nLänk till din låneansökan: {{signingLink}}${swedishTemplate.closing}`,
    variables: ["firstname", "signingLink"],
    templateType: "sms"
  },
  CONTROL_CALL: {
    templateName: "Control call",
    text: `${swedishTemplate.greeting}Vi behöver ställa dig några snabba frågor innan eventuellt lån kan betalas ut. Vänligen ta kontakt med oss på 0850928500, tack!${swedishTemplate.openingTimes}${swedishTemplate.closing}`,
    variables: ["firstname"],
    templateType: "sms"
  },
  CONTROL_CALL_INSURANCE: {
    templateName: "Control call - Insurance",
    text: "Hej {{firstname}}!\n\nVi har försökt nå dig med information som kan vara relevant för dig som kund hos Lea Bank. Ring oss gärna på 08-124 39 619.\n\nVänliga hälsningar Lea Bank",
    variables: ["firstname"],
    templateType: "sms"
  },
  MYMONEY_INSURANCE: {
    templateName: "MyMoney - Insurance call",
    text: `${swedishTemplate.greeting}Vi har försökt nå dig gällande ditt lån hos oss. Vänligen ring oss på telefonnummer 0812439619.${swedishTemplate.openingTimes}${swedishTemplate.closing}`,
    variables: ["firstname"],
    templateType: "sms"
  },
  TOPUP: {
    templateName: "TopUp",
    text: `${swedishTemplate.greeting}Vi har skickat ett preliminärt låneerbjudande till dig gällande utökning av ditt lån. Kontakta oss om du har frågor gällande din ansökan.\n\nLänk till din låneansökan: {{signingLink}}${swedishTemplate.closing}`,
    variables: ["firstname", "signingLink"],
    templateType: "sms"
  },
  EMAIL_SENT: {
    templateName: "We have sent an email",
    text: `${swedishTemplate.greeting}Vi har skickat e-post till dig gällande din låneansökan. Om du inte hittar det i din inkorg, kolla spam.\n\nHa en fortsatt trevlig dag!${swedishTemplate.closing}`,
    variables: ["firstname"],
    templateType: "sms"
  },
  MISSING_ERROR_ACCOUNT_NUMBER_SMS: {
    templateName: "Missing or error in account number",
    text: `${swedishTemplate.greeting}Det angivna kontonumret är felaktigt. Vänligen skicka in hela ditt clearing och kontonummer till kundservice@leabank.se eller ring oss på 08 509 285 00. Öppettiderna för vårt kundcenter är 09:00 till 15:00 måndag till fredag.\n\nLänk till din låneansökan: {{signingLink}}${swedishTemplate.closing}`,
    variables: ["firstname", "signingLink"],
    templateType: "sms"
  },
  NO_ANSWER_CARD_ACTIVATION: {
    templateName: "No answer",
    text: `${swedishTemplate.greeting}Innan ditt kreditkort kan aktiveras behöver vi ställa några snabba frågor. Vänligen ring oss på 0850928500, tack!${swedishTemplate.openingTimes}${swedishTemplate.closing}`,
    variables: ["firstname"],
    templateType: "mail"
  },
  CONTROL_CALL_CREDITCARD: {
    templateName: "Control call - Creditcard",
    text: `${swedishTemplate.greeting}Innan ditt kreditkort kan aktiveras behöver vi ställa några snabba frågor. Vänligen ring oss på 0850928500, tack!${swedishTemplate.openingTimes}${swedishTemplate.closing}`,
    variables: ["firstname"],
    templateType: "sms"
  }
};
